<template>
    <div class="mt-5 mb-5 validation-tab" v-if="!readOnly">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}.
                <span  v-if="!newTitle">
                   Validation du formulaire
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="tabulation-title m-auto" v-if="!disabled && hasField('INFO_COMPLEMENTAIRE')">
            <h5 style="font-size: 22px" v-if="getField('INFO_COMPLEMENTAIRE').name === null" :style="'color:' + titlesColor">
                Dialogue avec votre office de tourisme
            </h5>

            <h5 style="font-size: 22px" :style="'color:' + titlesColor" v-else>
                {{ getField('INFO_COMPLEMENTAIRE').name }}
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="panel" v-if="!disabled && hasField('INFO_COMPLEMENTAIRE')">
                <div class="panel-heading" v-if="getField('INFO_COMPLEMENTAIRE').helpDescription === null" :style="'color:' + fieldsColor">
                    Pour toutes informations ou demandes que vous souhaiteriez transmettre à votre office de tourisme
                </div>

                <div v-else :style="'color:' + fieldsColor">
                    {{ getField('INFO_COMPLEMENTAIRE').helpDescription }}
                </div>

                <div class="panel-body">
                    <v-textarea
                        class="textarea"
                        :value="extra"
                        @change="setExtra"
                        :readonly="disabled"
                        placeholder="- Nouvelles offres/tarifs
- Demandes diverses
- ..."
                        outlined>
                    </v-textarea>
                </div>

            </div>

            <div class="panel" v-if="!disabled && !readOnly">
                <div class="tabulation-title">
                    <h5 style="font-size: 22px" :style="'color:' + titlesColor">
                        Informations de la personne répondant
                    </h5>
                </div>
                <div class="panel-body">
                    <labeL :style="'color:' + fieldsColor" class="required">Prénom</labeL>
                    <v-text-field
                        :class="{'input-error': submitted && (contact.first_name === null || contact.first_name === '')}"
                        v-model="contact.first_name"
                        class="mb-5"
                        hide-details
                        autocomplete="new-first-name"
                        outlined>
                    </v-text-field>

                    <label :style="'color:' + fieldsColor" class="required">Nom</label>
                    <v-text-field
                        :class="{'input-error': submitted && (contact.last_name === null || contact.last_name === '')}"
                            v-model="contact.last_name"
                            class="mb-5"
                            hide-details
                            autocomplete="new-last-name"
                            outlined>
                    </v-text-field>

                    <label :style="'color:' + fieldsColor" class="required">E-mail</label>
                    <v-text-field
                            v-model="contact.email"
                            autocomplete="new-email"
                            outlined>
                    </v-text-field>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"
    import _ from "lodash"
    import * as EmailValidator from 'email-validator'

    export default {
        name: "Extra",
        props: ['index', "newTitle", "helpDesc"],
        methods: {
            ...mapMutations('web_form', [
                'setContact',
                'setExtra'
            ])
        },
        computed: {
            ...mapState('web_form', ['provider', 'contact', 'extra', 'submitted', 'disabled', 'readOnly',]),
            ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
            ...mapGetters('web_form', ['hasField', 'getField']),
        },
        watch: {
            contact: {
                handler: _.debounce(function() {
                    this.setContact(this.contact)
                }, 200),
                deep: true
            }
        },
    }
</script>
